module.exports = __webpack_public_path__ + "static/media/RaiseMe Messaging Screenshot.cf682f7d.png";